import React from 'react';

function WelcomePage() {
   const socialIcons = [
  { 
    name: 'LinkedIn', 
    icon: 'fab fa-linkedin-in', 
    color: 'hover:text-blue-400',
    link:'https://www.linkedin.com/in/santosh-doshi-jain-2a13b3246'
  },
  { 
    name: 'Whatsapp', 
    icon: 'fab fa-whatsapp', 
    color: 'hover:text-sky-400',
    link:'https://api.whatsapp.com/send/?phone=919975922007&text&type=phone_number&app_absent=0'
  },
  { 
    name: 'Facebook', 
    icon: 'fab fa-facebook-f', 
    color: 'hover:text-blue-600',
    link:'https://www.facebook.com/sanntosh.doshi?mibextid=ZbWKwL' 
  },
  { 
    name: 'Instagram', 
    icon: 'fab fa-instagram', 
    color: 'hover:text-pink-500', 
    link:'https://www.instagram.com/sanntoshdoshi/?igshid=https%3A%2F%2Finstagram.com'
  }
];

  const features = [
    { icon: '🌍', title: 'Global Trade', description: 'Master international business strategies' },
    { icon: '📚', title: 'Expert Courses', description: 'Learn from industry professionals' },
    { icon: '💼', title: 'Practical Training', description: 'Hands-on export-import experience' },
    { icon: '🎯', title: 'Career Growth', description: 'Boost your professional journey' }
  ];

  // Ensure URLs have a protocol so <a href> works correctly
  const ensureProtocol = (url: string) => {
    if (!url) return url;
    return /^https?:\/\//i.test(url) ? url : `https://${url}`;
  };

  // Inline styles for animations
  const animationStyles = `
    @keyframes fade-in-right {
      from {
        opacity: 0;
        transform: translateX(-50px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }

    @keyframes fade-in-left {
      from {
        opacity: 0;
        transform: translateX(50px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }

    @keyframes float {
      0%, 100% {
        transform: translateY(0px);
      }
      50% {
        transform: translateY(-20px);
      }
    }

    .animate-fade-in-right {
      animation: fade-in-right 1s ease-out forwards;
      opacity: 0;
    }

    .animate-fade-in-left {
      animation: fade-in-left 1s ease-out forwards;
      opacity: 0;
    }

    .animate-float {
      animation: float 6s ease-in-out infinite;
    }
  `;

  return (
    <>
      {/* Font Awesome CDN for icons (loaded here so icons render on this page) */}
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />
      {/* Inject animation styles */}
      <style>{animationStyles}</style>

      <div className="min-h-screen relative bg-gradient-to-br from-[#0B3F36] to-[#0A2F28] overflow-hidden">
        {/* Animated Background Elements */}
        <div className="absolute inset-0 overflow-hidden">
          {/* Main Background Image */}
          <div 
            className="absolute inset-0 bg-cover bg-center bg-no-repeat transform scale-110"
            style={{
              backgroundImage: 'url("https://images.unsplash.com/photo-1521737711867-e3b97375f902?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80")',
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-r from-[#0B3F36]/90 to-[#0A2F28]/80"></div>
          </div>
          
          {/* Floating Elements */}
          <div className="absolute top-20 left-10 w-6 h-6 bg-amber-400 rounded-full opacity-20 animate-float"></div>
          <div className="absolute top-40 right-20 w-8 h-8 bg-teal-300 rounded-full opacity-15 animate-float" style={{animationDelay: '2s'}}></div>
          <div className="absolute bottom-32 left-20 w-10 h-10 bg-white rounded-full opacity-10 animate-float" style={{animationDelay: '4s'}}></div>
          <div className="absolute bottom-20 right-32 w-5 h-5 bg-amber-300 rounded-full opacity-25 animate-float" style={{animationDelay: '1s'}}></div>
        </div>

        {/* Main Content */}
        <div className="relative z-10 min-h-screen flex items-center justify-center px-6 py-12">
          <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Content */}
            <div className="text-left space-y-8">
              {/* Welcome Text */}
              <div className="animate-fade-in-right">
                <p className="text-amber-300 text-lg md:text-xl font-semibold tracking-widest uppercase mb-2">
                  Welcome to
                </p>
              </div>

              {/* Main Title */}
              <div className="animate-fade-in-right" style={{animationDelay: '0.2s'}}>
                <h1 className="text-5xl md:text-5xl lg:text-5xl font-bold leading-tight">
                  <span className="text-white">SIDDHANT</span>
                  <br />
                  <span className="text-white">EXIM</span>
                  <span className="text-amber-400"> ACADEMY</span>
                </h1>
              </div>

             

              {/* Description */}
              <div className="animate-fade-in-right" style={{animationDelay: '0.6s'}}>
                <p className="text-lg md:text-xl text-gray-200 leading-relaxed max-w-2xl">
                  Empowering future leaders in international trade with comprehensive export-import 
                  education, practical training, and global business insights.
                </p>
              </div>

           

             {/* Social Icons */}
<div className="flex space-x-4 pt-4 animate-fade-in-right" style={{animationDelay: '1s'}}>
  {socialIcons.map((social, index) => (
    <a
      key={social.name}
      href={social.link}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={social.name}
      role="link"
      className="w-12 h-12 bg-white/10 rounded-xl border border-amber-400/30 flex items-center justify-center transform transition-all duration-300 hover:scale-110 hover:border-amber-400 backdrop-blur-sm"
      style={{ animationDelay: `${1.2 + index * 0.1}s` }}
      title={social.name}
    >
      <span className={`text-amber-300 text-lg hover:text-white transition-colors duration-300 ${social.color}`}>
        <i className={social.icon}></i>
      </span>
    </a>
  ))}
</div>
            </div>

            {/* Right Content - Features */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 animate-fade-in-left">
              {features.map((feature, index) => (
                <div 
                  key={feature.title}
                  className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 transform transition-all duration-300 hover:scale-105 hover:bg-white/15 hover:border-amber-400/30"
                  style={{ animationDelay: `${0.3 + index * 0.1}s` }}
                >
                  <div className="text-3xl mb-3">{feature.icon}</div>
                  <h3 className="text-white font-semibold text-lg mb-2">{feature.title}</h3>
                  <p className="text-teal-100 text-sm leading-relaxed">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-amber-400 rounded-full flex justify-center">
            <div className="w-1 h-3 bg-amber-400 rounded-full mt-2 animate-pulse"></div>
          </div>
        </div>

       
      </div>
    </>
  );
}

export default WelcomePage;